/**
 * loadScript: 加载脚本
 * @param urlOpts 加载脚本地址
 * @param scriptOpts 高级加载参数
 * @param cb 加载成功回调
 */
function loadScript(urlOpts, scriptOpts, cb) {
    let src = '';
    if (typeof urlOpts === 'object') {
        src = urlOpts.url;
        // 页面中存在该script 不加载了
        if (urlOpts.reg) {
            if (hasScript(urlOpts.reg)) {
                cb();
                return;
            }
        }
    }
    else {
        src = urlOpts;
    }
    let head = document.head || document.getElementsByTagName('head')[0];
    let script = document.createElement('script');
    script.type = scriptOpts.type || 'text/javascript';
    script.async = 'async' in scriptOpts ? !!scriptOpts.async : true;
    if (scriptOpts.crossOrigin) {
        script.crossOrigin = 'anonymous'; // 定位问题加跨域
    }
    script.src = src;
    if (scriptOpts.attrs) {
        setAttributes(script, scriptOpts.attrs);
    }
    if (scriptOpts.text) {
        script.text = '' + scriptOpts.text;
    }
    let onend = 'onload' in script ? stdOnEnd : ieOnEnd;
    onend(script, cb);
    // some good legacy browsers (firefox) fail the 'in' detection above
    // so as a fallback we always set onload
    // old IE will ignore this and new IE will set onload
    if (!script.onload) {
        stdOnEnd(script, cb);
    }
    head.appendChild(script);
}
function setAttributes(script, attrs) {
    for (let attr in attrs) {
        script.setAttribute(attr, attrs[attr]);
    }
}
function stdOnEnd(script, cb) {
    script.onload = function () {
        this.onerror = this.onload = null;
        cb(null, script);
    };
    script.onerror = function () {
        this.onerror = this.onload = null;
        cb(new Error('Failed to load ' + this.src), script);
    };
}
function ieOnEnd(script, cb) {
    script.onreadystatechange = function () {
        if (this.readyState !== 'complete' && this.readyState !== 'loaded')
            return;
        this.onreadystatechange = null;
        cb(null, script); // there is no way to catch loading errors in IE8
    };
}
function hasScript(srcReg) {
    let ret = false;
    for (let s in document.scripts) {
        let src = document.scripts[s].src;
        if (src !== '') {
            if (new RegExp(srcReg).exec(src)) {
                ret = true;
            }
        }
    }
    return ret;
}
let loadings = {};
let cbs = {}; //
let loaded = false;
let isBridgeReady = false;
/**
 * 全局的sdk ready回调
 * @param sdk sdk 顶级命名空间 如  shareSDK
 * @param sdkName  唯一标识当前sdk的名称 最好和 sdk 顶级命名空间一致方便记忆
 */
function callHandlers(sdk, sdkName) {
    if (isBridgeReady) {
        while (cbs[sdkName].length) {
            let fn = cbs[sdkName].shift();
            fn.call(this, sdk);
        }
    }
}
/**
 * 特殊的依赖bridgeReady的特殊库需要，如司机端bridge
 * @param sdkUrlOpts
 * @param bridgeReadyName
 * @param sdkName
 */
function bridgeReady(sdkUrlOpts, bridgeReadyName, sdkName) {
    // 强制执行 锁
    let lock = false;
    if (isBridgeReady) {
        sdkCall(sdkUrlOpts, sdkName);
    }
    else {
        document.addEventListener(bridgeReadyName, function () {
            lock = true;
            isBridgeReady = true;
            sdkCall(sdkUrlOpts, sdkName);
        });
        // bac 如果1秒不执行ready 强制回调执行
        setTimeout(function () {
            isBridgeReady = true;
            if (!lock) {
                sdkCall(sdkUrlOpts, sdkName);
            }
        }, 1000);
    }
}
/**
 *
 * @param sdkName
 * @param sdkUrlOpts
 * @param callback
 * @param bridgeReadyName
 * @returns
 */
function sdkReady(sdkName, sdkUrlOpts, callback, bridgeReadyName) {
    // load 回调队列
    !cbs[sdkName] && (cbs[sdkName] = []);
    cbs[sdkName].push(callback);
    // 有依赖 bridge ready
    if (bridgeReadyName) {
        bridgeReady(sdkUrlOpts, bridgeReadyName, sdkName);
        return;
    }
    else {
        isBridgeReady = true;
    }
    sdkCall(sdkUrlOpts, sdkName);
}
function sdkCall(sdkUrlOpts, sdkName) {
    // 已经加载过了，并且防止 页面特殊的id
    if (window[sdkName] && typeof window[sdkName] === 'object') {
        if (sdkName === 'Omega') { // 兼容Omega必须提前声明appkey的情况
            if (window.Omega.trackEvent) {
                loaded = true;
                callHandlers(window[sdkName], sdkName);
            }
            else {
                loaded = false;
            }
        }
        else {
            loaded = true;
            callHandlers(window[sdkName], sdkName);
        }
    }
    else {
        loaded = false;
    }
    // 正在加载，防止load成功之前连续加载
    if (!loadings[sdkName]) {
        !loaded && (loadings[sdkName] = true) && loadScript(sdkUrlOpts, {}, function (err) {
            if (err) {
                // load err
                callHandlers(err, sdkName);
                return;
            }
            loaded = true;
            // 这里先用定时器轮训判断js是否真正的加载完成
            // 多个if大部分场景会快速执行一些 by yanchaoren
            if (typeof window[sdkName] !== 'undefined') {
                callHandlers(window[sdkName], sdkName);
            }
            else {
                const sdkInter = setInterval(() => {
                    if (typeof window[sdkName] !== 'undefined') {
                        if (sdkName === 'Omega') { // 兼容Omega必须提前声明appkey的情况
                            if (window.Omega.trackEvent) {
                                window.clearInterval(sdkInter);
                                callHandlers(window[sdkName], sdkName);
                            }
                        }
                        else {
                            window.clearInterval(sdkInter);
                            callHandlers(window[sdkName], sdkName);
                        }
                    }
                }, 1000 / 60);
            }
        });
    }
}
const sdkReadyPromise = (sdkName, sdkUrlOpts) => new Promise(resolve => {
    sdkReady(sdkName, sdkUrlOpts, () => resolve());
});
export { loadScript, sdkReady, sdkReadyPromise };
